module.exports = __webpack_public_path__ + "img/6.24400a83.png";